"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            overflow: 'visible',
        },
        paper: {
            width: 300 + theme.spacing(4),
            boxSizing: 'border-box',
            position: 'relative',
            padding: theme.spacing(3, 2, 1, 2),
            backgroundColor: '#FAFAFA',
            zIndex: 'auto',
            boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.1),0px 5px 8px 0px rgba(0, 0, 0, 0.07),0px 1px 14px 0px rgba(0, 0, 0, 0.06)',
            overflow: 'visible',
            marginTop: 11,
        },
        arrow: {
            position: 'absolute',
            top: -32,
            right: 30,
            width: 32,
            height: 32,
            overflow: 'hidden',
            boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
            '&::after': {
                content: '""',
                position: 'absolute',
                borderTopLeftRadius: 2,
                width: 16,
                height: 16,
                backgroundColor: '#FAFAFA',
                transform: 'rotate(45deg)',
                top: 24,
                left: 8,
                boxShadow: '-1px -1px 10px -5px rgba(0, 0, 0, 0.5)',
            },
        },
    });
});
var PomodoroPopover = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Popover, __assign({ classes: { root: classes.root, paper: classes.paper }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, other),
        children,
        react_1.default.createElement("div", { className: classes.arrow })));
};
exports.default = PomodoroPopover;
//# sourceMappingURL=PomodoroPopover.js.map